import styled from 'styled-components'

import { white, blue } from '../../styles/colors'
import { minmedia, maxmedia } from '../../styles/media-queries'

export const StatusBar = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background: ${blue};
  opacity: 0.8;
  border-radius: 0.25rem;
  color: ${white};
  line-height: 1.5;
  width: 100%;
  a {
    color: ${white};
  }
  ${maxmedia.medium`
    font-size: 15px;
    line-height: 1.2;
  `};
  ${minmedia.xmlarge`
    width: calc(70% - 1rem);
  `};
`



// WEBPACK FOOTER //
// ./src/views/ShoppingCart/styles.js